module.exports = __webpack_public_path__ + "view/2019/img/closeBook_rtl.png";